import React from 'react';
import { motion } from 'framer-motion';
export function PainPoints() {
  return <section className="py-24 px-4 bg-black" data-id="element-176" data-mp="2ln2hwezvnnsn">
      <div className="max-w-3xl mx-auto" data-id="element-177" data-mp="2lm0wphp5dkx7">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-178" data-mp="26yfsfkgjdfnp">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-179" data-mp="1y043rnz8crxw">
            Does this sound familiar?
          </h2>
          <p className="text-lg text-gray-300 leading-relaxed bg-navy-card p-6 rounded-2xl border border-navy-border" data-id="element-180" data-mp="1nzts47sufsku">
            Sunday night. 10pm. You have Spanish class tomorrow morning. And you
            are still there — searching for activities, trying to build a lesson
            that actually flows, that works for your students, that feels
            professional and intentional instead of something you threw together
            in twenty minutes.
            <br data-id="element-181" data-mp="1yykhbo9v9s5z" />
            <br data-id="element-182" data-mp="1u1ll906n7b55" />
            <span className="text-gold-light font-medium" data-id="element-183" data-mp="1u23rmpn0r5qs">
              Not because you don't know Spanish. Not because you're not a good
              teacher.
            </span>{' '}
            Because no one ever gave you a complete, ready-to-teach system.
            You've been building every lesson from scratch. The time you should
            be resting — you're spending it planning. And the worst part isn't
            the exhaustion. The worst part is walking into the classroom feeling
            like you could have been better prepared.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-184" data-mp="1k3nxedsp3gd2">
          <h3 className="text-xl font-bold text-white mb-8 text-center" data-id="element-185" data-mp="2vkxe4skfvuao">
            The real cost of not having the right resource:
          </h3>

          <ul className="space-y-4" data-id="element-186" data-mp="1y36vcy1x15a2">
            {['Sunday nights lost searching for activities, grammar explanations and speaking tasks that actually work together', 'Lessons that feel repetitive — because you keep going back to the same exercises you know', 'Visible improvisation that quietly chips away at your confidence as a teacher', 'No real variety between weeks — and students who slowly lose motivation without knowing why', 'Weekends spent planning instead of resting, recovering or living your life', 'No clear progression — just a collection of disconnected activities that never build into a real curriculum'].map((point, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4 bg-navy-card p-4 rounded-xl border border-red-900/30" data-id="element-187" data-mp="qotx89zponge" data-mpi={i}>
                <span className="text-red-500 mt-1" data-id="element-188" data-mp="57nppfx3saak">🔴</span>
                <span className="text-gray-300" data-id="element-189" data-mp="59793fe231gk">{point}</span>
              </motion.li>)}
          </ul>

          <div className="text-center mt-12 pt-8 border-t border-navy-border" data-id="element-190" data-mp="3rmpa30yjli25">
            <p className="text-2xl font-serif font-bold text-gold-gradient" data-id="element-191" data-mp="3rkm8rkrxw2i4">
              Stop giving away your free time. Your dedication is already there.
              What you need now is the right tool.
            </p>
            <p className="text-xl mt-4 text-white" data-id="element-192" data-mp="3dnfqdrb4o5tf">
              Plan a full year of Spanish classes today.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}